import { render, staticRenderFns } from "./admin-create.vue?vue&type=template&id=501f38da&scoped=true&"
import script from "./admin-create.vue?vue&type=script&lang=js&"
export * from "./admin-create.vue?vue&type=script&lang=js&"
import style0 from "./admin-create.vue?vue&type=style&index=0&id=501f38da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "501f38da",
  null
  
)

export default component.exports